import { isValidPhoneValidationCode } from 'logic/phone-validation-code/phone-validation-code.validator';
import { clearEmptyFields } from 'logic/validators/utils';
import { isRequiredValidator } from 'logic/validators/validators';
import { FormErrors } from 'redux-form';

export const VERIFY_PHONE_NUMBER_FORM_NAME = 'verify-phone-number';

export enum VerifyPhoneNumberField {
  verificationCode = 'verificationCode',
}

export interface VerifyPhoneNumberFormValues {
  [VerifyPhoneNumberField.verificationCode]?: string;
}

export type VerifyPhoneNumberFormValidationErrors = FormErrors<VerifyPhoneNumberFormValues, any>;

export const validateVerifyPhoneForm = (formValues: VerifyPhoneNumberFormValues) => {
  const { verificationCode } = formValues;

  const errors: VerifyPhoneNumberFormValidationErrors = {
    verificationCode:
      isRequiredValidator(verificationCode) || isValidPhoneValidationCode(verificationCode),
  };

  return clearEmptyFields(errors);
};
